var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',{staticClass:"text-center table-loading",attrs:{"colspan":_vm.cols}},[(_vm.text)?_c('span',[_vm._v("\n        "+_vm._s(_vm.text)+"...\n      ")]):_c('span',[_vm._v("\n        Laddar...\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25db24a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Partials/TableLoader.vue
// module id = 465
// module chunks = 0